import { Identifiable, Task } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  { allocations }: Identifiable<Task>,
  { resources }: Filter,
): boolean {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find(({ uuid }) =>
      allocations.find((allocation) => uuid === allocation.resource.uuid),
    )
  );
}

export { isFilteredByResources };
